export const routes = [
  {
    name: "Getting Started",
    pages: [
      {
        name: "Installation",
        route: "installation",
      },
      {
        name: "License",
        route: "license",
      },
      {
        name: "What is Tailwind CSS",
        route: "what-is-tailwind-css",
      },
      {
        name: "Release Notes",
        route: "release-notes",
      },
    ],
  },
  {
    name: "Integration Guide",
    pages: [
      {
        name: "React",
        route: "guide/react-vite",
      },
      {
        name: "Next.js",
        route: "guide/next",
      },
      {
        name: "Vue",
        route: "guide/vue-vite",
      },
      {
        name: "Nuxt.js",
        route: "guide/nuxt",
      },
      {
        name: "Svelte",
        route: "guide/svelte",
      },
      {
        name: "Laravel",
        route: "guide/laravel",
      },
      {
        name: "Angular",
        route: "guide/angular",
      },
      {
        name: "Remix",
        route: "guide/remix",
      },
      {
        name: "Meteor.js",
        route: "guide/meteor",
      },
      {
        name: "Gatsby",
        route: "guide/gatsby",
      },
      {
        name: "Solid.js",
        route: "guide/solid",
      },
      {
        name: "Qwik",
        route: "guide/qwik",
      },
      {
        name: "Symfony",
        route: "guide/symfony",
      },

      {
        name: "Phoenix",
        route: "guide/phoenix",
      },
      {
        name: "Django",
        route: "guide/django",
      },
      {
        name: "Flask",
        route: "guide/flask",
      },
    ],
  },
  {
    name: "Customization",
    pages: [
      {
        name: "Theming",
        route: "theming",
      },
      {
        name: "Colors",
        route: "colors",
      },
      {
        name: "Fonts",
        route: "fonts",
      },
      {
        name: "Shadows",
        route: "shadows",
      },
      {
        name: "Screens",
        route: "screens",
      },
    ],
  },
  {
    name: "Components",
    pages: [
      {
        name: "Accordion",
        route: "accordion",
      },
      {
        name: "Alert",
        route: "alert",
      },
      {
        name: "Avatar",
        route: "avatar",
      },
      {
        name: "Badge",
        route: "badge",
      },
      {
        name: "Breadcrumbs",
        route: "breadcrumbs",
      },
      {
        name: "Button",
        route: "button",
      },
      {
        name: "Button Group",
        route: "button-group",
      },

      {
        name: "Card",
        route: "card",
      },
      {
        name: "Checkbox",
        route: "checkbox",
      },
      {
        name: "Chip",
        route: "chip",
      },
      {
        name: "Collapse",
        route: "collapse",
      },
      {
        name: "Dialog",
        route: "dialog",
      },
      {
        name: "Footer",
        route: "footer",
      },
      {
        name: "Form",
        route: "form",
      },
      {
        name: "Gallery",
        route: "gallery",
      },
      {
        name: "Icon Button",
        route: "icon-button",
      },
      {
        name: "Image",
        route: "image",
      },
      {
        name: "Input",
        route: "input",
      },
      {
        name: "Input Number",
        route: "input-number",
      },
      {
        name: "Input Phone",
        route: "input-phone",
      },
      {
        name: "Input Search",
        route: "input-search",
      },

      {
        name: "List",
        route: "list",
      },
      {
        name: "Menu",
        route: "menu",
      },
      {
        name: "Mega Menu",
        route: "mega-menu",
      },
      {
        name: "Modal",
        route: "modal",
      },
      {
        name: "Navbar",
        route: "navbar",
      },
      {
        name: "Pagination",
        route: "pagination",
      },
      {
        name: "Popover",
        route: "popover",
      },
      {
        name: "Progress Bar",
        route: "progress-bar",
      },
      {
        name: "Radio Button",
        route: "radio-button",
      },
      {
        name: "Rating",
        route: "rating",
      },
      {
        name: "Select",
        route: "select",
      },
      {
        name: "Sidebar",
        route: "sidebar",
      },
      {
        name: "Skeleton",
        route: "skeleton",
      },
      // {
      //   name: "Slider",
      //   route: "slider",
      // },
      {
        name: "Speed Dial",
        route: "speed-dial",
      },
      {
        name: "Spinner",
        route: "spinner",
      },
      {
        name: "Stepper",
        route: "stepper",
      },
      {
        name: "Switch",
        route: "switch",
      },
      {
        name: "Tabs",
        route: "tabs",
      },
      {
        name: "Table",
        route: "table",
      },
      {
        name: "Textarea",
        route: "textarea",
      },
      {
        name: "Timeline",
        route: "timeline",
      },
      {
        name: "Tooltip",
        route: "tooltip",
      },
      {
        name: "Typography",
        route: "typography",
      },

      {
        name: "Video",
        route: "video",
      },
    ],
  },
  {
    name: "Plugins",
    pages: [
      {
        name: "Algolia Search",
        route: "plugins/algolia-search",
      },
      {
        name: "Charts",
        route: "plugins/charts",
      },
      {
        name: "Clipboard",
        route: "plugins/clipboard",
      },
      {
        name: "Date Picker",
        route: "plugins/date-picker",
      },
      {
        name: "WSSIWYG Editor",
        route: "plugins/text-editor",
      },
    ],
  },
];
